import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmModalComponent, ConfirmModalData } from '../confirm-modal/confirm-modal.component';

@Component({
    selector: 'ah-tooltip',
    templateUrl: './tooltip.component.html',
    styleUrls: ['./tooltip.component.scss'],
    standalone: false
})
export class TooltipComponent {
    @Input() isWarning = false;
    @Input() tooltip: string;

    constructor(public dialog: MatDialog) { }

    openDialog() {
        const data: ConfirmModalData = {
            allowCancel: false,
            title: ``,
            message: this.tooltip,
            confirmButton: 'Confirm',
        };

        this.dialog.open(ConfirmModalComponent, { data });
    }
}
